// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.inline-card-cont[data-v-0e929d76] {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: center;\n}\n.inline-card-cont[data-v-0e929d76] .dx-field {\r\n    margin: 0 10px;\n}\n.tep-tmp-open-btn[data-v-0e929d76] {\r\n    display: flex;\r\n    align-items: end;\r\n    height: 66px;\r\n    padding: 10px 0;\n}\r\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
